// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + {"6823":"__federation_expose_mount","7367":"vendor-blueprint"}[chunkId] + "." + {"6823":"e5e8153944d0db9b1000","7367":"51c5210627b0fade5107"}[chunkId] + ".css";
};